module.exports = __webpack_public_path__ + "assets/img/icon-wb-6b888be7.png";